import {
  insertTransactionReport,
  insertTransactionReportExcel,
  getUserCodes,
  getTransactionReport,
} from "../../api/transaction-report";
import { UTCToLocale, localeToUTC } from "@/utilities/date.js";
import { fileDownload } from "@/utilities/downloadFile.js";

import moment from "moment";

const eDate = moment().format("YYYY-MM-DD");
const sDate = moment()
  .subtract(7, "d")
  .format("YYYY-MM-DD");

const transactionReport = {
  namespaced: true,
  state: () => ({
    transactions: {},
    userCodes: [],
    transactionRecords: {},
    form: {
      start_date: sDate + "T00:00:00Z",
      end_date: eDate + "T23:59:59Z",
      is_all_clients_selected: true,
      client_ids: [],
      is_all_programs_selected: true,
      program_ids: [],
      is_all_user_code_selected: true,
      user_codes: [],
      is_all_transactions_selected: true,
      show_my_transaction: false,
      transaction_types: [],
      show_total: true,
      sort_on: "fullname",
      sub_total_by: [],
      export_to_excel: false,
      email: "",
    },
    name: "",
  }),

  getters: {
    getTransactionReport: (state) => {
      return state.transactions;
    },
    getUserCodes: (state) => {
      return state.userCodes;
    },
    getTransactionRecords: (state) => {
      return state.transactionRecords;
    },
  },

  actions: {
    addTransactionReport({ commit }, { form, params }) {
      return new Promise((resolve, reject) => {
        insertTransactionReport(form, params)
          .then((resp) => {
            if (
              resp.headers["content-type"] === "application/json; charset=utf-8"
            ) {
              commit("SET_TRANSACTION_REPORT", resp.data);
            }
            resolve(resp.data);
          })
          .catch(() => {
            console.log("error from transaction report action");
          });
      });
    },
    addTransactionReportExcel({ commit }, form) {
      return new Promise((resolve, reject) => {
        insertTransactionReportExcel(form)
          .then((resp) => {
            console.log(resp.data);
            if (resp.data == true) {
              alert("Email sent successfully");
            } else {
              alert("Failed to send email");
            }
            resolve(resp.data);
          })
          .catch(() => {
            console.log("error from transaction report action");
          });
      });
    },
    fetchUserCodes({ commit }) {
      return new Promise((resolve, reject) => {
        getUserCodes()
          .then((resp) => {
            commit("SET_USER_CODES", resp.data);
            resolve(resp.data);
          })
          .catch(() => {
            console.log("error from transaction report action");
          });
      });
    },
    fetchTransactionReport({ commit }, params) {
      return new Promise((resolve, reject) => {
        getTransactionReport(params)
          .then((resp) => {
            // resp.data.Result.map((record) => {
            //   record.date = UTCToLocale(record.date);
            // });
            commit("SET_TRANSACTION_REPORT_USER", resp.data);
            resolve(resp.data);
          })
          .catch(() => {
            console.log("error from transaction report action");
          });
      });
    },
  },

  mutations: {
    SET_TRANSACTION_REPORT: (state, transactions) => {
      state.transactions = transactions;
    },
    SET_USER_CODES: (state, userCodes) => {
      state.userCodes = userCodes;
    },
    SET_TRANSACTION_REPORT_USER: (state, transactionRecords) => {
      state.transactionRecords = transactionRecords;
    },
    RESET_STATE: (state) => {
      state.form = {
        start_date: sDate + "T00:00:00Z",
        end_date: eDate + "T23:59:59Z",
        is_all_clients_selected: true,
        client_ids: [],
        is_all_programs_selected: true,
        program_ids: [],
        is_all_user_code_selected: true,
        user_codes: [],
        is_all_transactions_selected: true,
        show_my_transaction: false,
        transaction_types: [],
        show_total: true,
        sort_on: "fullname",
        sub_total_by: [],
        export_to_excel: false,
        email: "",
      };
    },
  },
};

export default transactionReport;
